const enum StorageKey {
    AUTH_CODE = 'AUTH_CODE',
    APPROVAL_TOKEN = 'APPROVAL_TOKEN',
}

export default StorageKey
